import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";

const WHATSAPP_NUMBER = "916374730489"; // no + sign
const DEFAULT_MSG = "Hi, I'm visiting your online store and need some help";

const WhatsAppWidget = ({ inNavbar }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const openWhatsApp = () => {
    const msg = encodeURIComponent(DEFAULT_MSG);
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${msg}`;
    window.open(url, "_blank");
  };

  return (
    <>
      {/* Desktop Floating Button */}
      {!inNavbar && !isMobile && (
        <button
          className="whatsapp-fab"
          aria-label="Chat on WhatsApp"
          onClick={openWhatsApp}
        >
          <FaWhatsapp size={27} />
        </button>
      )}

      {/* Mobile Navbar Icon */}
      {inNavbar && isMobile && (
        <button
          className="whatsapp-navbar"
          aria-label="Chat on WhatsApp"
          onClick={openWhatsApp}
          style={{
            background: "none",
            border: "none",
            padding: "0 6px",
            cursor: "pointer",
          }}
        >
          <FaWhatsapp size={23} style={{ color: "#25d366" }} />
        </button>
      )}

      <style>{`
        .whatsapp-fab {
          position: fixed;
          right: 33px;
          bottom: 38px;
          z-index: 2061;
          background: #25d366;
          color: #fff;
          border: none;
          border-radius: 50%;
          box-shadow: 0 4px 16px rgba(0,0,0,0.13);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: box-shadow 0.21s, background 0.23s;
          width: 50px;
          height: 50px;
        }

        .whatsapp-fab:hover {
          background: #128c7e;
          box-shadow: 0 8px 24px rgba(39,187,94,0.22);
        }
      `}</style>
    </>
  );
};

export default WhatsAppWidget;
